import { DialogHost, Toaster } from "@cafe/ui";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router";
import { useBootstrapSession } from "@/features/auth/session";
import { queryClient } from "@/shared/api/query-client";
import { ApprovalHost } from "@/shared/ui/approval-host";
import { router } from "./router";


/** Корневые провайдеры. DialogHost/Toaster монтируются один раз здесь. */
export function App() {
  useBootstrapSession();
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <DialogHost />
      <ApprovalHost />
      <Toaster />
    </QueryClientProvider>
  );
}
